import { ProductVariantsMatrix as ProductVariantsMatrixComponent } from './ProductVariantsMatrix';
import { withContainer } from './withContainer';

const ProductVariantsMatrix = withContainer(ProductVariantsMatrixComponent);

export { ProductVariantsMatrix, ProductVariantsMatrixComponent };
export * from './withContainer';
